"use client";

import * as React from "react";
import PhoneInputFromLib, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export interface PhoneInputProps {
  value?: string;
  onChange: (value?: string | any) => void;
  className?: string;
  placeholder?: string;
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  id?: string;
  defaultCountry?: any;
}

export const PhoneInput = React.forwardRef<any, PhoneInputProps>(
  ({ className = "", error, ...props }, ref) => {
    return (
      <div
        className={`
          flex h-10 w-full items-center rounded-md border bg-white px-3 py-2 text-sm
          focus-within:outline-none focus-within:ring-2 focus-within:ring-black/5
          ${error ? "border-red-500 focus-within:ring-red-500/20" : "border-neutral-300"}
          ${props.disabled ? "cursor-not-allowed opacity-50" : ""}
          ${className}
          [&_.PhoneInput]:flex [&_.PhoneInput]:w-full [&_.PhoneInput]:items-center
          [&_.PhoneInputCountry]:mr-2
          [&_.PhoneInputInput]:w-full [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:placeholder:text-neutral-400
        `}
      >
        <PhoneInputFromLib
          ref={ref}
          defaultCountry="US"
          {...props}
        />
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";
export { isValidPhoneNumber };
